import DepartmentSign from '@/components/Common/DepartmentSign';

// @vue/component
export default {
  name: 'DepartmentSignature',

  components: {
    DepartmentSign,
  },

  props: {
    department: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    assignedAgents() {
      return this.department.assigned_agents ? this.department.assigned_agents.split(',').length : 0;
    },
  },
};
